import React from 'react';
import { ToolbarMenu, ToolbarMenuItem } from 'ceci-ui';
import { BarChart, InsertInvitation, Group, Favorite } from "@material-ui/icons";
import { NavLink } from 'react-router-dom';

function HeaderMenu() {
  return (
    <ToolbarMenu>
      <ToolbarMenuItem component={NavLink} exact to="/">
        <BarChart />
        Visão Geral
      </ToolbarMenuItem>
      <ToolbarMenuItem component={NavLink} exact to="/charges">
        <InsertInvitation />
        Cobranças
      </ToolbarMenuItem>
      <ToolbarMenuItem component={NavLink} exact to="/clients">
        <Group />
        Clientes
      </ToolbarMenuItem>
      <ToolbarMenuItem component={NavLink} exact to="/promotions">
        <Favorite />
        Indique e ganhe
      </ToolbarMenuItem>
      <ToolbarMenuItem component={NavLink} exact to="/help">
        <Group />
        Ajuda
      </ToolbarMenuItem>
    </ToolbarMenu>
  )
};

export default HeaderMenu;
